package com.patronat.top.client.data.location

import com.patronat.top.client.location.ClientGeoLocation
import com.patronat.top.client.location.ClientLocationSuggestion
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult

class ClientLocationSearchRepository(
    private val remoteDataSource: MapTilerLocationRemoteDataSource
) {
    suspend fun searchLocations(
        query: String,
        proximity: ClientGeoLocation?
    ): DomainResult<List<ClientLocationSuggestion>> {
        return remoteDataSource.searchLocations(
            query = query,
            proximity = proximity
        ).asDomainResult { it }
    }

    suspend fun reverseGeocode(location: ClientGeoLocation): DomainResult<ClientLocationSuggestion?> {
        return remoteDataSource.reverseGeocode(location).asDomainResult { it }
    }
}
